import {ChevronDownIcon, ChevronUpIcon} from '@primer/octicons-react'
import {ButtonGroup, IconButton} from '@primer/react'
import {useDiffNavigation} from '../../hooks/use-diff-navigation'

export function ReviewNavigationButtonGroup() {
  const {navigateToPrevious, navigateToNext} = useDiffNavigation()

  return (
    <ButtonGroup>
      <IconButton
        icon={ChevronUpIcon}
        aria-label="Previous file (K)"
        size="small"
        onClick={navigateToPrevious}
        data-hotkey="k"
      />
      <IconButton
        icon={ChevronDownIcon}
        aria-label="Next file (J)"
        size="small"
        onClick={navigateToNext}
        data-hotkey="j"
      />
    </ButtonGroup>
  )
}

try{ ReviewNavigationButtonGroup.displayName ||= 'ReviewNavigationButtonGroup' } catch {}